var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar',{on:{"side-menu-pressed":_vm.toggleNavDrawer}}),_c('nav-drawer',{attrs:{"side-nav":_vm.toggle,"is-logged-in":_vm.isLoggedIn},on:{"update-navigation-prop":_vm.updateDrawerProp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }